import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { cn } from '../../lib/utils';

// Sidebar + topbar widths are defined in tokens.css:
//   --sidebar-w: 240px / --sidebar-w-mini: 72px / --topbar-h: 60px
// Tailwind exposes them as: w-sidebar, w-sidebar-mini, h-topbar, pt-topbar, ml-sidebar
export function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-bg">
      <Sidebar
        collapsed={sidebarCollapsed}
        mobileOpen={mobileOpen}
        onToggle={() => setSidebarCollapsed((prev) => !prev)}
        onMobileClose={() => setMobileOpen(false)}
      />
      <TopBar
        sidebarCollapsed={sidebarCollapsed}
        onMobileMenuOpen={() => setMobileOpen(true)}
      />
      <main
        className={cn(
          'pt-topbar transition-[margin] duration-DEFAULT ease-ease',
          sidebarCollapsed ? 'md:ml-sidebar-mini' : 'md:ml-sidebar',
          'ml-0',
        )}
      >
        <div className="p-4 md:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
